import { Controller, useFormContext } from 'react-hook-form';
import { MdOutlineLink } from 'react-icons/md';
import { Input } from '@ds';
import { BaseCommercialAviaLegSchemaValues } from '@lp/features/RoutePlanner/components/RouteLegForm/validation';
import { useLegFormContext } from '@lp/features/RoutePlanner/components/RouteLegForm/context/LegFormContext';
import { RecommendedFlightLegType } from '@/api/apis/route';
import { ConnectedLegDetails } from './ConnectedLegDetails';

type ConnectedLegsFormProps = {
  index: number;
  connectedLeg?: RecommendedFlightLegType;
};

export const ConnectedLegsForm = ({ index, connectedLeg }: ConnectedLegsFormProps) => {
  const { isOptionalDataEdit } = useLegFormContext();
  const { control } = useFormContext<BaseCommercialAviaLegSchemaValues>();

  return (
    <div className="flex flex-col gap-6">
      {!!connectedLeg && (
        <div className="flex gap-2 items-center">
          <div className="text-base-5">
            <MdOutlineLink size={18} />
          </div>
          <span className="text-m-m text-base-5">
            {connectedLeg.departureAirportIATA} - {connectedLeg.arrivalAirportIATA}
          </span>
        </div>
      )}
      <ConnectedLegDetails type="departureLocation" index={index} />
      <ConnectedLegDetails type="arrivalLocation" index={index} />
      <div className="flex gap-4">
        <div className="w-60">
          <Controller
            name={`connectedLegs.${index}.flightNumber`}
            control={control}
            render={({ field, fieldState: { invalid } }) => (
              <Input
                size="md"
                aria-label="Flight Number *"
                label="Flight Number *"
                placeholder="Flight Number"
                isInvalid={invalid}
                isDisabled
                {...field}
              />
            )}
          />
        </div>
        <div className="w-[140px]">
          <Controller
            name={`connectedLegs.${index}.bookingNumber`}
            control={control}
            render={({ field, fieldState: { invalid } }) => (
              <Input
                size="md"
                aria-label="Booking Number"
                label="Booking Number"
                placeholder="Booking Number"
                isInvalid={invalid}
                isDisabled={!isOptionalDataEdit}
                {...field}
              />
            )}
          />
        </div>
      </div>
    </div>
  );
};
